import { LicenceTypeId } from "../payment/payment";

export class TenantLicenceRequest {
  id: string | undefined;
  tenantId: string | undefined;
  actionType: LicenceActionType;
  licenceType: LicenceTypeId;
  licenceCount: string | undefined;
  status: LicenceActionStatus;
  paymentProviderFulfillmentDateTime : string | undefined;


  constructor(payload?: any) {
    if (payload) {
      this.id = payload.id;
      this.tenantId = payload?.tenantId;
      this.actionType = payload?.actionType;
      this.licenceType = payload?.licenceType;
      this.licenceCount = payload?.licenceCount;
      this.status = payload?.status;
      this.paymentProviderFulfillmentDateTime = payload?.paymentProviderFulfillmentDateTime;
    }
  }
   /**
   * creates users from a result
   * @param result Array of any
   * @returns Array of TenantLicenceRequest
   */
   static createTenantLicenceRequests(result: Array<any>): TenantLicenceRequest[] {
    const requests = new Array<TenantLicenceRequest>();
    if (result) {
      result.map((request) => {
        requests.push(new TenantLicenceRequest(request));
      });
    }
    return requests;
  }
}

export class TenantLicenceRequestInput {
  id: string | undefined;
  tenantId: string | undefined;
  actionType: LicenceActionType;
  licenceType: LicenceTypeId;
  licenceCount: string | undefined;

  constructor(payload?: any) {
    if (payload) {
      this.id = payload.id;
      this.tenantId = payload?.tenantId;
      this.actionType = payload?.actionType;
      this.licenceType = payload?.licenceType;
    }
  }
}

export enum LicenceActionType {
  ADD, REMOVE
}

enum LicenceActionStatus {
  NEW, PROCESSING, DONE, CANCELED
}
